// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + chunkId + "." + {"362": "cd4cdb92","484": "cdd9baf4",}[chunkId] + ".css"
}